import React from 'react';

/** Top-left ROI pill beside the SaaS phone mockup */
export default function SaasHeroRoiFloat({ compact = false, centered = false }) {
  return (
    <div
      className={`saas-roi-float rounded-2xl bg-white border border-emerald-100/90 shadow-[0_20px_44px_-8px_rgba(16,185,129,0.22)] px-3.5 ${
        compact ? 'py-2.5' : 'py-3'
      } ${
        compact && centered
          ? 'w-full'
          : compact
            ? 'ml-auto w-[min(240px,calc(100vw-5rem))]'
            : 'ml-auto w-full max-w-[17rem]'
      }`}
    >
      <p
        className={`font-semibold uppercase tracking-[0.12em] text-emerald-700/90 ${
          compact ? 'text-[9px] mb-0.5' : 'text-[10px] mb-1'
        }`}
      >
        Highest ROI this month
      </p>
      <p className={`text-gray-900 leading-snug ${compact ? 'text-[11px]' : 'text-[11px] md:text-[12px]'}`}>
        <span className={`font-bold text-emerald-700 tabular-nums ${compact ? '' : 'text-[13px]'}`}>
          $12k ARR saved
        </span>
        <span className="text-gray-400"> · </span>
        <span className="text-gray-700">3 churn saves queued</span>
      </p>
      <style jsx>{`
        .saas-roi-float {
          animation: saasRoiFloat 4.5s ease-in-out infinite;
        }
        @keyframes saasRoiFloat {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-7px);
          }
        }
      `}</style>
    </div>
  );
}
